// Login-as (incognito) sessions are marked for the browser tab: the `incognito` query only survives
// the first navigation, so without the mark a reload or a full page load turned the agent's session
// into the customer's (Intercom boot, activity writes, the redirect to elsa-v3). sessionStorage is
// per tab and ends with it. Same key in elsa-v3/src/utils/redesignHandoff.ts.
const LOGIN_AS_SESSION_KEY = 'riseup.loginAsSession';

// `incognito=true` in any case, the first of repeated params; elsa-v3's isLoginAsQuery reads it alike.
function isIncognitoQuery(value) {
  const single = Array.isArray(value) ? value[0] : value;
  return single === true || String(single ?? '').toLowerCase() === 'true';
}

// The query marks the tab; a later load without it reads the mark.
function resolveIncognito(queryIncognito) {
  try {
    if (isIncognitoQuery(queryIncognito)) {
      sessionStorage.setItem(LOGIN_AS_SESSION_KEY, 'true');
      return true;
    }
    return sessionStorage.getItem(LOGIN_AS_SESSION_KEY) === 'true';
  } catch (error) {
    // Storage unavailable (private mode): the query is all there is.
    return isIncognitoQuery(queryIncognito);
  }
}

// The tab carries the mark (storage available and set).
function isMarked() {
  try {
    return sessionStorage.getItem(LOGIN_AS_SESSION_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

// A login of the customer's own (code login, logout) ends the login-as session in this tab.
function clearIncognito() {
  try {
    sessionStorage.removeItem(LOGIN_AS_SESSION_KEY);
  } catch (error) {
    // Storage unavailable: nothing was marked.
  }
}

export default { isIncognitoQuery, resolveIncognito, isMarked, clearIncognito };
